<template>
  <!-- AppSettingsScreen do app: sobe de baixo no celular (como o AppSheet), modal grande no desktop -->
  <ModalComponent
    :id="settingsModalId" size="modal-lg"
    :title="info.screenTitle"
    modal-class="app-sheet app-sheet-tall text-primary"
    backdrop="true"
  >
    <template v-slot:body>
      <LoadingContainer v-if="loading" />
      <div v-else class="text-paragraph settings-text" v-html="text"></div>
    </template>
  </ModalComponent>
</template>
<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { SETTINGS_TITLES, type SettingsKey, useSettingsText } from "@/composables/useSettings";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";

const settingsModalId = "settings-modal";
const EVENT_KEYS: Record<string, SettingsKey> = { terms: "terms-of-use", policy: "privacy-policy" };

const key = ref<SettingsKey | "">("");
const info = computed(() => ({ screenTitle: key.value ? SETTINGS_TITLES[key.value] : "" }));
const { data: text, isFetching: loading } = useSettingsText(key);

const open = (data: { key: string }) => {
  key.value = EVENT_KEYS[data.key] ?? "";
  toggleModal(settingsModalId);
};
onMounted(() => EventBus.$on(EventBusNames.SHOW_SETTINGS_MODAL, open));
onBeforeUnmount(() => EventBus.$off(EventBusNames.SHOW_SETTINGS_MODAL, open));
</script>
